import React from 'react';
export function WhyNow() {
  return <section className="py-12 md:py-20 px-5 bg-cream-50" data-id="element-220">
      <div className="max-w-3xl mx-auto" data-id="element-221">
        <div className="text-center mb-8 md:mb-12" data-id="element-222">
          <p className="text-xs uppercase tracking-[0.2em] text-olive-600 font-medium mb-4" data-id="element-223">
            Una mirada honesta
          </p>
          <h2 className="font-serif font-medium text-3xl md:text-4xl text-ink-900 leading-tight" data-id="element-224">
            ¿Cuántas veces buscaste una{' '}
            <span className="italic text-olive-600" data-id="element-225">pastilla</span> sin pensar
            si había otra opción?
          </h2>
        </div>

        <div className="prose prose-lg max-w-none text-ink-700 space-y-5 text-base md:text-lg leading-relaxed" data-id="element-226">
          <p data-id="element-227">
            Antes, muchas familias sabían cómo aliviar molestias simples del día
            a día con cosas que tenían en la cocina. Una infusión para dormir
            mejor, una compresa para un dolor, una preparación para una mala
            digestión.
          </p>
          <p data-id="element-228">
            Con el tiempo, dejamos de usar esos conocimientos. Y hoy es muy
            común sentir que dependemos de la farmacia hasta para lo más
            cotidiano.
          </p>
          <p className="text-ink-900 font-medium" data-id="element-229">
            Esta guía no busca reemplazar a nadie. Lo que sí hace es ordenar, en
            un solo lugar, soluciones naturales simples y tradicionales para que
            las tengas a mano cuando las necesites.
          </p>
        </div>

        {/* Soft contrast pull-quote */}
        <div className="mt-10 md:mt-14 border-l-2 border-olive-400 pl-6 py-2" data-id="element-230">
          <p className="font-serif italic text-xl md:text-2xl text-ink-800 leading-snug" data-id="element-231">
            "Recuperar hábitos naturales no es ir contra nada. Es sumar
            herramientas para vivir un poco más tranquilos."
          </p>
        </div>
      </div>
    </section>;
}